import { Component, OnInit } from '@angular/core';
import { NbSidebarService } from '@nebular/theme';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed style="
    background: linear-gradient(90deg, #004e92, #0077b6, #00a3cc, #4fb0c6, #b0bec5);">
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive [state]="'compacted'" [collapsedBreakpoints]="[]">
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed style="z-index: 100;">
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements OnInit {
  constructor(private sidebarService: NbSidebarService) {}

  ngOnInit(): void {
    // Nebular: estado "compacted" = barra fina com ícones (não oculta). Força após o layout renderizar.
    setTimeout(() => this.sidebarService.compact('menu-sidebar'), 0);
  }
}
